const _temp0 = require("./bleu.png");
const _temp1 = require("./bleu_left.png");
const _temp2 = require("./bleu_right.png");
const _temp3 = require("./dauphin.png");
const _temp4 = require("./dauphin_left.png");
const _temp5 = require("./dauphin_right.png");
const _temp6 = require("./dragon.png");
const _temp7 = require("./dragon_left.png");
const _temp8 = require("./dragon_right.png");
const _temp9 = require("./ecureuil.png");
const _temp10 = require("./ecureuil_left.png");
const _temp11 = require("./ecureuil_right.png");
const _temp12 = require("./foret_papier.png");
const _temp13 = require("./foret_papier_2.png");
const _temp14 = require("./foret_papier_3.png");
const _temp15 = require("./foret_papier_4.png");
const _temp16 = require("./grenouille.png");
const _temp17 = require("./grenouille_left.png");
const _temp18 = require("./grenouille_right.png");
const _temp19 = require("./grue_2.png");
const _temp20 = require("./grue_2_left.png");
const _temp21 = require("./grue_2_right.png");
const _temp22 = require("./hibou.png");
const _temp23 = require("./hibou_left.png");
const _temp24 = require("./hibou_right.png");
const _temp25 = require("./hirondelle.png");
const _temp26 = require("./hirondelle_left.png");
const _temp27 = require("./hirondelle_right.png");
const _temp28 = require("./maman_renard.png");
const _temp29 = require("./maman_renard_left.png");
const _temp30 = require("./maman_renard_right.png");
const _temp31 = require("./ours.png");
const _temp32 = require("./ours_left.png");
const _temp33 = require("./ours_right.png");
const _temp34 = require("./papillon.png");
const _temp35 = require("./papillon_left.png");
const _temp36 = require("./papillon_right.png");
const _temp37 = require("./petit_renard.png");
const _temp38 = require("./petit_renard_2.png");
const _temp39 = require("./petit_renard_2_left.png");
const _temp40 = require("./petit_renard_2_right.png");
const _temp41 = require("./poisson.png");
const _temp42 = require("./poisson_left.png");
const _temp43 = require("./poisson_right.png");
const _temp44 = require("./poupees.png");
const _temp45 = require("./renard.png");
const _temp46 = require("./requin.png");
const _temp47 = require("./requin_left.png");
const _temp48 = require("./requin_right.png");
const _temp49 = require("./rose_cropped_left.png");
const _temp50 = require("./rose_cropped_right.png");
const _temp51 = require("./rose_left.png");
const _temp52 = require("./rose_right.png");
const _temp53 = require("./sanglier.png");
const _temp54 = require("./sanglier_left.png");
const _temp55 = require("./sanglier_right.png");
module.exports = {
  "bleu": _temp0,
  "bleu_left": _temp1,
  "bleu_right": _temp2,
  "dauphin": _temp3,
  "dauphin_left": _temp4,
  "dauphin_right": _temp5,
  "dragon": _temp6,
  "dragon_left": _temp7,
  "dragon_right": _temp8,
  "ecureuil": _temp9,
  "ecureuil_left": _temp10,
  "ecureuil_right": _temp11,
  "foret_papier": _temp12,
  "foret_papier_2": _temp13,
  "foret_papier_3": _temp14,
  "foret_papier_4": _temp15,
  "grenouille": _temp16,
  "grenouille_left": _temp17,
  "grenouille_right": _temp18,
  "grue_2": _temp19,
  "grue_2_left": _temp20,
  "grue_2_right": _temp21,
  "hibou": _temp22,
  "hibou_left": _temp23,
  "hibou_right": _temp24,
  "hirondelle": _temp25,
  "hirondelle_left": _temp26,
  "hirondelle_right": _temp27,
  "maman_renard": _temp28,
  "maman_renard_left": _temp29,
  "maman_renard_right": _temp30,
  "ours": _temp31,
  "ours_left": _temp32,
  "ours_right": _temp33,
  "papillon": _temp34,
  "papillon_left": _temp35,
  "papillon_right": _temp36,
  "petit_renard": _temp37,
  "petit_renard_2": _temp38,
  "petit_renard_2_left": _temp39,
  "petit_renard_2_right": _temp40,
  "poisson": _temp41,
  "poisson_left": _temp42,
  "poisson_right": _temp43,
  "poupees": _temp44,
  "renard": _temp45,
  "requin": _temp46,
  "requin_left": _temp47,
  "requin_right": _temp48,
  "rose_cropped_left": _temp49,
  "rose_cropped_right": _temp50,
  "rose_left": _temp51,
  "rose_right": _temp52,
  "sanglier": _temp53,
  "sanglier_left": _temp54,
  "sanglier_right": _temp55
}